import { useSafeLocalStorage } from '../../lib/safeLocalStorage';

const darkRef = useSafeLocalStorage('uc-dark-mode', true);

export default function useDark() {
  return darkRef;
}
